import * as Yup from 'yup';

const phoneNumberUpdateSchema = Yup.object().shape({
    ftm_contact_number: Yup.string().required('Phone number is required')
});

export default phoneNumberUpdateSchema;
